/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_close-simple': {
    width: 512,
    height: 512,
    viewBox: '0 0 512.001 512.001',
    data: '<path pid="0" d="M512.001 84.853L427.148 0 256.001 171.147 84.853 0 0 84.853 171.148 256 0 427.148l84.853 84.853 171.148-171.147 171.147 171.147 84.853-84.853L340.853 256z"/>'
  }
})
